<template>
  <el-time-select v-model="timeValue" :placeholder="placeHolderData" :clearable="false" :editable="false" :picker-options="{ start: '00:00', step: '00:15', end: '23:45'}" @change="changePickerValue"></el-time-select>
</template>

<script>
import isNil from 'lodash/isNil';
import isUndefined from 'lodash/isUndefined';
import { EMPTY_TEXT } from '@/utils/string';
import moment from 'moment';

export default {
  name: 'WTimePickerByMin',
  props: {
    timeData: Number,
    timeType: String,
    rowData: {
      type: Object,
      default: () => {},
    },
    placeHolderData: String,
  },
  data() {
    return {
      timeValue: '',
    };
  },
  watch: {
    timeData: {
      handler() {
        if (!isNil(this.timeData)) {
          this.timeValue = this.convertDatetime(this.timeData);
        }
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * [convertDatetime 파라미터로 받아온 데이터 형태가 long이기 때문에 HH:mm 형태로 변환해야한다.]
     * @author yelim
     */
    convertDatetime(value) {
      if (isNil(value)) {
        return EMPTY_TEXT;
      }
      return moment(new Date(value)).format('HH:mm');
    },
    /**
     * [changePickerValue rowData를 props로 전달받은 경우는 테이블에서 사용하는 경우, timetype을 전달받은 경우는 팝업에서 사용시]
     * @author  yelim
     */
    changePickerValue() {
      if (!isUndefined(this.rowData)) {
        this.$emit('change', this.timeValue, this.rowData, this);
      } else {
        this.$emit('change', this.timeValue, this.timeType, this);
      }
    },
    setValue(time) {
      this.timeValue = this.convertDatetime(time);
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/server/SecuritySettings/component/TimePickerByMin.vue